import { Divider } from "@/components/shared/divider";
import { useRoute } from "@/components/shared/router";
import { Button, CardContent, View } from "@/components/ui";
import { useGiftCardsByFiltersQuery } from "@/gqlhooks/gift-card/useGiftCardsByFiltersQuery";
import { isLastItem } from "@/lib/utils";

import { GiftCardHistoryEmpty } from "./gift-card-history-empty";
import { GiftCardHistoryItem } from "./gift-card-history-item";
import { GiftCardHistorySkeleton } from "./gift-card-history-skeleton";
import type { AccountGiftCardHistoryProps } from "./types";

export const AccountGiftCardHistory = ({ filter = {} }: AccountGiftCardHistoryProps) => {
  const { push } = useRoute();
  const { tab, limit } = filter;

  const { list: allItems, loading } = useGiftCardsByFiltersQuery({ tab });
  // TODO
  // consider to handle the limit using graphql
  const visibleItems = typeof limit === "number" ? allItems.slice(0, limit) : allItems;
  const count = allItems.length;

  const handleViewAll = () => {
    push({ pageKey: "giftCardHistory" });
  };

  const shouldShowViewAll = () => {
    return typeof limit === "number" && count > visibleItems.length;
  };

  return (
    <CardContent>
      {loading ? (
        <GiftCardHistorySkeleton />
      ) : visibleItems.length > 0 ? (
        visibleItems.map((item, index) => (
          <View key={item.id}>
            <GiftCardHistoryItem item={item} />
            {/* TODO */}
            {/* the lastItem styles can be handle directly on component styling */}
            {!isLastItem(index, visibleItems.length) && <Divider />}
            {isLastItem(index, visibleItems.length) && shouldShowViewAll() && (
              <View className="flex flex-col items-center py-6">
                <Button
                  variant="secondary"
                  color="CTA2"
                  size={"md"}
                  rounded="full"
                  onClick={handleViewAll}
                >
                  View All
                </Button>
              </View>
            )}
          </View>
        ))
      ) : (
        <GiftCardHistoryEmpty />
      )}
    </CardContent>
  );
};
